import React, { Component, Fragment, useRef } from 'react';
import platform from "Pub/js/platform";
import { cloneDeep } from 'lodash';
import { langCheck } from "Pub/js/utils.js";
import { getMultiLangDisplayText } from './common';
import './WatermarkEditor.less';
import Svg from '../../../components/Svg';

const { NCModal, NCButton, NCMultiLangText, NCMenu, NCDropdown, NCIcon, NCHotKeys, NCTooltip } = platform.base;
const { getLangCode, toast } = platform;
const { Item } = NCMenu;

function closest(el, selector) {
    if (!el) {
        return null;
    }
    const matchesSelector = el.matches || el.webkitMatchesSelector || el.mozMatchesSelector || el.msMatchesSelector;

    while (el) {
        if (matchesSelector.call(el, selector)) {
            break;
        }
        el = el.parentElement;
    }
    return el;
}

class SysVarCard extends Component {

    render() {
        const { item, className, disabled, deleteBtn, title, label, ...rest } = this.props;
        
        return (
            <li
                draggable={!disabled}
                className={`sysvar-item ${className || ''} ${disabled ? 'disabled' : ''}`}
                title={title || item.display}
                fieldid={item.value}
                {...rest}
            >
                <div className="sysvar-text">
                    {
                        label ? label : item.display
                    }
                    
                </div>
            </li>
        );
    }
}

class DefTextModal extends Component {

    render() {
        const { show, modalCancel, modalConfirm, multiLangOptions, nodeData = {}, json, topContainer } = this.props;
        const value = this.getValue(nodeData, multiLangOptions);
        this.nodeData = nodeData;
        return (
            <NCModal 
                container={topContainer}
                fieldid="deftext-modal"
                dialogClassName='watermark-setting-modal'
                show={show}
                size="sm"
                resizable={false}
                onHide={modalCancel}
            >
                <NCModal.Header closeButton>
                    {/* 自定义文本 */}
                    <NCModal.Title>{langCheck('Watermark-000038', 'pages', json)}</NCModal.Title>
                </NCModal.Header>
                <NCModal.Body className="watermark-setting">
                    <div className="watermark-setting-panel in-modal">
                        <div className="fields-wrap">
                            <div className={`field-area field-langtext`}>
                                <div className="deftext-label">
                                    {/* 自定义文本 */}
                                    {langCheck('Watermark-000038', 'pages', json)}
                                </div>
                                <div className="field-item">
                                    <NCMultiLangText
                                        value={value}
                                        languageMeta={multiLangOptions}
                                        attrcode={'langtext'}
                                        onChange={this.onChange.bind(this)}
                                        maxlength={60}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                    
                </NCModal.Body>
                <NCModal.Footer>
                <NCHotKeys
                        keyMap={{
                            confirmHandle: NCHotKeys.USUAL_KEYS.MODAL_CONFIRM,
                            cancelHandler: NCHotKeys.USUAL_KEYS.MODAL_CANCEL,
                        }}
                        handlers={{
                            confirmHandle: () => { modalConfirm(this.nodeData); },
                            cancelHandler: () => { modalCancel(); },
                        }}
                        focused={true}
                    />
                    <NCTooltip
                        overlay={`${langCheck('Watermark-000001', 'pages', json /* 确定 */)}(${NCHotKeys.USUAL_KEYS.MODAL_CONFIRM})`}
                    >
                        <NCButton 
                            fieldid="watermark-confirm" 
                            colors="primary"
                            onClick={() => {modalConfirm(this.nodeData); }} 
                        >
                            {langCheck('Watermark-000001', 'pages', json) /*确定*/}
                            (<span className="underline">Y</span>)
                        </NCButton>
                    </NCTooltip>
                    <NCTooltip
                        overlay={`${langCheck('Watermark-000000', 'pages', json /* 取消 */)}(${NCHotKeys.USUAL_KEYS.MODAL_CANCEL})`}
                    >
                        <NCButton
                            fieldid="watermark-cancel"
                            colors="secondary"
                            onClick={() => {modalCancel();}}
                        >
                            {langCheck('Watermark-000000', 'pages', json) /*取消*/}
                            (<span className="underline">N</span>)
                        </NCButton>
                    </NCTooltip>
                </NCModal.Footer>
            </NCModal>
        );
    }

    getValue(nodeData, multiLangOptions = []) {
        const { code, ...rest } = nodeData;
        let value = {};
        multiLangOptions.forEach(opt => {
            value[`langtext${opt.index}`] = { value: rest[`value${opt.index}`] || '' };
        });
        return value;
    }

    onChange(value) {
        const { nodeData } = this.props;
        let curNodeData = { ...nodeData };
        for (let key in value) {
            curNodeData[`value${value[key].index}`] = value[key].value;
        }
        this.nodeData = curNodeData;
    }
}

class WatermarkEditor extends Component {
    constructor(props) {
        super(props);
        this.state = { 
            value: this.props.value || [],
            showModal: false,
            expand: false,
            oprIconHovered: '', // wrap edit delete
        };
        this.sysVarsList = null;
        this.editor = null;
        
    }

    render() {
        return (
            <div className="watermark-editor-wrap">
                {this.renderSysVars()}
                {this.renderEditorContent()}
                {this.renderDefTextModal()}
            </div>
        );
    }

    shouldComponentUpdate(nextProps) {
        const { value } = nextProps;
        if (value !== this.props.value) {
            this.setState({ value });
        }
        return true;
    }

    renderSysVars() {
        const { expand } = this.state;
        const { sysvars, disabled, json } = this.props;
        const evetns = !disabled ? {
            onDragStart: this.onDragStart.bind(this),
            onDrag: this.onDrag.bind(this),
            onDragEnd: this.onDragEnd.bind(this),
        } : {};
        return (
            
            <ul
                className="sysvars-list"
                ref={el => {
                    this.sysVarsList = el;
                }}
            >
                {
                    sysvars.map((item, index) => {
                        // 默认展示7个
                        const itemStyle = (expand || index < 7) ? {} : { display: 'none' };
                        return (
                            <SysVarCard
                                disabled={disabled}
                                key={`var-${index}`}
                                item={item}
                                {...evetns}
                                onClick={!disabled && this.onClick.bind(this, item)}
                                style={itemStyle}
                            />
                        );
                    })
                }
                <div className='expand-trigger' onClick={() => {
                    this.setState({
                        expand: !expand
                    })
                }}>
                    <p className='trigger-text'>{langCheck(expand ? 'Watermark-000056' : 'Watermark-000055', 'pages', json)}</p>
                    <i className={`iconfont ${expand ? 'icon-jiantoushang' : 'icon-jiantouxia' }`}></i>
                </div>
            </ul>
        );
    }

    checkIsFull() {
        const { json, topContainer } = this.props;
        const { value } = this.state;
        let ret = value.length === 4;
        if (ret) {
            toast({
                content: langCheck('Watermark-000042', 'pages', json), // 文字水印模版不超过4个字段
                color: 'danger',
                container: topContainer
            });
        }
        return ret;
    }

    onClick(item, e) {
        const sortNodes = cloneDeep(this.state.value);
        if (this.checkIsFull()) {
            return;
        }
        let nodeData = this.initNodeData({ code: item.value, local: item.display });
        this.setCurDrag(e.currentTarget);
        if (item.value === '&[deftext]') {
            this.setState({
                showModal: true,
                curNodeData: nodeData,
            });
        } else {
            this.addNewNode(sortNodes, nodeData);
        }
    }

    initNodeData(item) {
        const { multiLangOptions } = this.props;
        const localCode = getLangCode();
        const nodeData = { code: item.code };
        if (item.code === '&[deftext]') {
            multiLangOptions.forEach(opt => {
                nodeData[`value${opt.index}`] = opt.languageCode === localCode ? item.local : '';
            });
            nodeData.status = 'add';
        }
        return nodeData;
    }

    renderEditorContent() {
        const { value, oprIconHovered } = this.state;
        const { disabled, json } = this.props;
        const contentClassName = `editor-content ${disabled ? 'editor-content-disabled' : ''}`;
        const events = !disabled ? {
            onDragOver: this.onDragOver.bind(this),
            onDrop: this.onDrop.bind(this),
            onDragEnter: this.onDragEnter.bind(this),
            onDragLeave: this.onDragLeave.bind(this),
        } : {};
        const cardEvents = !disabled ? {
            onDragStart: this.onDragStart.bind(this),
            onDrag: this.onDrag.bind(this),
            onDragEnd: this.onDragEnd.bind(this),
            onDrop: this.onDrop.bind(this),
            onDragLeave: this.onDragLeave.bind(this),
        } : {};
        return (
            <div
                className={contentClassName}
                // contentEditable
                // contentEditable = "plaintext-only"
                ref={el => {
                    this.editor = el;
                }}
                {...events}
            >
                {
                    value.map((item, index) => {
                        let cardData = this.getCardDataByCode(item);
                        let isDefTxt = item.code === '&[deftext]';
                        let title = getMultiLangDisplayText(item, 'value', this.props.multiLangOptions);
                        if (isDefTxt && !title) {
                            title = langCheck('Watermark-000051', 'pages', json);
                        } else {
                            title = item.value || cardData.display;
                        }
                        let label = <React.Fragment>
                            <div className='opr-icons'>
                                <Svg
                                    className="wrap-icon"
                                    xlinkHref={
                                        item.isWrap 
                                        ? oprIconHovered === 'wrap' ? '#icon-morenzhanshi-xuanting' : '#icon-morenzhanshi'
                                        : oprIconHovered === 'wrap' ? '#icon-a-zhehangxuanting' : '#icon-zhehang'
                                    }
                                    width={16}
                                    height={16}
                                    title={langCheck(item.isWrap ? 'Watermark-000041' : 'Watermark-000040', 'pages', json)}
                                    onMouseEnter={() => { this.setState({ oprIconHovered: 'wrap' }) }}
                                    onMouseLeave={() => { this.setState({ oprIconHovered: '' }) }}
                                    onClick={this.setWrap.bind(this, index)}
                                />
                                {
                                    isDefTxt && <Svg
                                        className="edit-icon"
                                        xlinkHref={
                                            oprIconHovered === 'edit'
                                            ? '#icon-bianji-xuanting'
                                            : '#icon-bianji2'
                                        }
                                        width={16}
                                        height={16}
                                        title={langCheck('Watermark-000039', 'pages', json)}
                                        onMouseEnter={() => { this.setState({ oprIconHovered: 'edit' }) }}
                                        onMouseLeave={() => { this.setState({ oprIconHovered: '' }) }}
                                        onClick={this.editNode.bind(this, index)}
                                    />
                                }
                                <Svg
                                    className="delete-icon"
                                    xlinkHref={
                                        oprIconHovered === 'delete'
                                        ? '#icon-shanchu-xuanting'
                                        : '#icon-shanchu7'
                                    }
                                    width={16}
                                    height={16}
                                    title={langCheck('Watermark-000054', 'pages', json)}
                                    onMouseEnter={() => { this.setState({ oprIconHovered: 'delete' }) }}
                                    onMouseLeave={() => { this.setState({ oprIconHovered: '' }) }}
                                    onClick={this.deleteNode.bind(this, index)}
                                />
                            </div>
                            <div className={`tpl-item-title ${isDefTxt ? 'deftxt' : ''}`}>
                                {title}
                            </div>
                        </React.Fragment>;
                        return (
                            <React.Fragment key={`card-${index}`}>
                                {
                                    item.isWrap && (
                                        <div className="line-break"></div>
                                    )
                                }
                                <SysVarCard
                                    id={`card_${index}`}
                                    disabled={disabled}
                                    className="tpl-item"
                                    key={`card-${index}`}
                                    item={cardData}
                                    title={title}
                                    label={label}

                                    {...cardEvents}
                                />
                            </React.Fragment>
                        );
                    })
                }
            </div>
        );
    }

    setCurDrag(target) {
        this.dragNode = target.cloneNode(true);
        let id = this.dragNode.getAttribute('id');
        if (target.classList.contains('tpl-item')) {
            this.dragIndex = parseInt(id.split('_')[1]);
        } else {
            this.dragIndex = -1;
        }
    }

    setCurDragEnter(target) {
        this.curDragEnterNode = {
            id: target.getAttribute('id'),
            index: parseInt(target.getAttribute('id').split('_')[1]),
            el: target
        };
    }

    getCardDataByCode(item) {
        const { sysvars } = this.props;
        let ret = sysvars.find(el => el.value === item.code);
        return { ...ret, ...item };
    }

    onDragStart(e) {
        e.stopPropagation();
        this.setCurDrag(e.target);
        // console.log('dragStart', this.dragNode, this.dragNode.getAttribute('fieldid'));
    }

    onDrag(e) {
        e.stopPropagation();
        const curDragEnterNode = this.curDragEnterNode;
        if (curDragEnterNode && curDragEnterNode.el) {
            curDragEnterNode.el.classList.remove('drag-over-gap-prev');
            curDragEnterNode.el.classList.add('drag-over-gap-next');
        }
        // console.log('drag', e, this.curDragEnterNode);
    }

    onDragEnd(e) {
        e.stopPropagation();
        console.log('dragEnd', e);
        this.clearDragGap();
    }

    onDragOver(e) {
        const { target, pageX } = e;
        e.preventDefault();
        e.stopPropagation();
        console.log('dragOver', e, this.dragNode, e.target, e.currentTarget);
        const dragOverEl = closest(target, '.tpl-item');
        if (dragOverEl) {
            const rect = dragOverEl.getBoundingClientRect();
            this.dragOverIndex = parseInt(dragOverEl.getAttribute('id').split('_')[1]);
            this.clearDragGap();
            if (pageX < rect.left + rect.width / 2 && pageX > rect.left) {
                dragOverEl.classList.add('drag-over-gap-prev');
                this.dragOverIndex = this.dragOverIndex > 0 ? this.dragOverIndex - 1 : 0;
            } else if (pageX > rect.left + rect.width / 2 && pageX < rect.right) {
                dragOverEl.classList.add('drag-over-gap-next');
                this.dragOverIndex = this.dragOverIndex + 1;
            }
            
            console.log('onDragOver', dragOverEl.getAttribute('id'), dragOverEl);
        }
        return false;
    }

    onDrop(e) {
        const { json } = this.props;
        e.preventDefault();
        e.stopPropagation();
        console.log('drop', e);
        let { target } = e;
        let sortNodes = cloneDeep(this.state.value);
        const dropTarget = closest(target, '.tpl-item');
        let dropPosition = dropTarget ? parseInt(dropTarget.getAttribute('id').split('_')[1]) : -1;
        if (this.curDragEnterNode) {
            dropPosition = parseInt(this.curDragEnterNode.index);
        }
        if (this.dragIndex === -1) {
            // TODO 新增模版字段节点
            // const dragNodeData = { code: this.dragNode.getAttribute('fieldid') };
            if (this.checkIsFull()) {
                this.clearDragGap();
                return;
            }
            const dragNodeData = this.initNodeData({
                code: this.dragNode.getAttribute('fieldid'),
                local: langCheck('Watermark-000038', 'pages', json),
            });
            
            if (target.classList.contains('editor-content')) {
                if (dragNodeData.code === '&[deftext]') {
                    this.setState({
                        showModal: true,
                        curNodeData: dragNodeData,
                    });
                } else {
                    this.addNewNode(sortNodes, dragNodeData);
                }
            }
            if (dropPosition > -1) {
                if (dropTarget.classList.contains('drag-over-gap-next')) {
                    dropPosition += 1;
                }
                if (dragNodeData.code === '&[deftext]') {
                    this.setState({
                        showModal: true,
                        curNodeData: dragNodeData,
                    });
                    this.dropPosition = dropPosition;
                } else {
                    this.addNewNode(sortNodes, dragNodeData, dropPosition);
                }

            }
        } else {
            // TODO 排序模版字段
            if (this.dragIndex === dropPosition || dropPosition === -1) {
                return;
            }
            if (this.dragIndex < dropPosition) {
                dropPosition = dropTarget && dropTarget.classList.contains('drag-over-gap-prev') ? dropPosition - 1 : dropPosition;
            }
            if (this.dragIndex > dropPosition) {
                dropPosition = dropTarget && dropTarget.classList.contains('drag-over-gap-next') ? dropPosition + 1 : dropPosition;
            }
            this.sortNode(sortNodes, dropPosition, this.dragIndex);
        }
        this.clearDragGap();
    }

    addNewNode(sortNodes, nodeData, dropPosition) {
        const { onChange } = this.props;
        if (dropPosition >= 0) {
            sortNodes.splice(dropPosition, 0, nodeData);
        } else {
            sortNodes.push(nodeData);
        }
        this.setState({ value: sortNodes });
        onChange && onChange(sortNodes);
    }

    sortNode(sortNodes, dropPosition, dragIndex) {
        const { onChange } = this.props;
        sortNodes.splice(dropPosition, 0, sortNodes.splice(dragIndex, 1)[0]);
        this.setState({ value: sortNodes });
        onChange && onChange(sortNodes);
    }

    deleteNode(index) {
        const { onChange } = this.props;
        let sortNodes = cloneDeep(this.state.value);
        sortNodes.splice(index, 1);
        this.setState({ value: sortNodes });
        onChange && onChange(sortNodes);
    }

    editNode(index) {
        let nodeData = this.state.value[index];
        this.dropPosition = index;
        this.setState({
            showModal: true,
            curNodeData: nodeData,
        });
    }

    setWrap(index) {
        const { onChange } = this.props;
        const sortNodes = cloneDeep(this.state.value);
        let nodeData = sortNodes[index];
        nodeData.isWrap = !nodeData.isWrap;
        this.setState({ value: sortNodes });
        onChange && onChange(sortNodes);
    }

    onDragEnter(e) {
        e.preventDefault();
        e.stopPropagation();
        // console.log('dragEnter', e.target, e.currentTarget);
        if (e.target.classList.contains('editor-content')) {
            e.target.classList.add('drag-enter');
        } 
        if (e.target.classList.contains('tpl-item')) {
            this.setCurDragEnter(e.target);
        }
    }

    onDragLeave(e) {
        e.preventDefault();
        e.stopPropagation();
        // console.log('dragLeave', e.target, e.currentTarget);
        let target = e.target;
        if (target.classList.contains('editor-content')) {
            target.classList.remove('drag-enter');
            this.curDragEnterNode = null;
        }
        this.clearDragGap();
    }

    clearDragGap() {
        Array.from(document.querySelectorAll('.tpl-item')).forEach(el => {
            el.classList.remove('drag-over-gap-prev');
            el.classList.remove('drag-over-gap-next');
        });
    }

    defTextModalCancel() {
        this.setState({ showModal: false, curNodeData: {} });
    }

    defTextModalConfirm(nodeData) {
        const { onChange, json, multiLangOptions, topContainer } = this.props;
        const localCode = getLangCode();
        const langMeta = multiLangOptions.find(el => el.languageCode === localCode);
        const sortNodes = cloneDeep(this.state.value);
        let { status, ...rest } = nodeData;
        const { code, ...values } = rest;
        let valid = true;
        let msg = '';
        for(let key in values) {
            if (key === `value${langMeta.index}` && values[key].length === 0) {
                valid = false;
                msg = langCheck('Watermark-000052', 'pages', json); // 自定义文本不能为空
            }
        }
        if (!valid) {
            toast({
                content: msg,
                color: 'danger',
                container: topContainer
            });
            return;
        }
        if (status === 'add') {
            this.addNewNode(sortNodes, rest, this.dropPosition);
        } else {
            sortNodes[this.dropPosition] = { ...rest };
            this.setState({ value: sortNodes });
            onChange && onChange(sortNodes);
        }
        delete this.dropPosition;
        this.defTextModalCancel();
    }
    
    renderDefTextModal() {
        const { showModal, curNodeData } = this.state;
        const { multiLangOptions, json, topContainer } = this.props;
        
        return (
            <DefTextModal
                json={json}
                multiLangOptions={multiLangOptions}
                show={showModal}
                nodeData={curNodeData}
                modalCancel={this.defTextModalCancel.bind(this)}
                modalConfirm={this.defTextModalConfirm.bind(this)}
                topContainer={topContainer}
            />
        );
    }
}

export default WatermarkEditor;